import useStore from "./useStore.js";
export var useResult = id => {
  var store = useStore();
  if (!id) return {
    result: null,
    isExcluded: true
  };else {
    var _store$results$get;
    return {
      result: (_store$results$get = store.results.get(id)) !== null && _store$results$get !== void 0 ? _store$results$get : null,
      isExcluded: !store.filteredResults.ids.has(id)
    };
  }
};
export default useResult;
//# sourceMappingURL=useResult.js.map